<template>
  <div id="pdf-content">
    <div class="pdf-container">
      <!-- INGLES -->
      <div class="pdf-page-break">
        <div class="table-header">
          <table>
            <tbody>
              <tr>
                <td width="50%">
                  <img src="@/assets/images/logo-h.png" class="pdf-logo" />
                </td>
                <td>
                  <p>{{ user.name }} {{ user.lastname }}</p>
                  <p>Accepted: {{ user.creation_date }}</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h1><span>Last updated: 09/06/2025</span> TERMS AND CONDITIONS</h1>
        <p>
          These Oliverlist Terms and Conditions (the <strong>“General Conditions”</strong>)
          govern the relationship between <strong>Aivoni</strong>, a société, par actions
          simplifiée, registered with the Trade and Commercial Register of
          Nanterre under the number 808 785 166, with a share capital of 20,000
          euros, whose head office is located at 4 Avenue JB Clément 92100,
          Boulogne-Billancourt, France (<strong>“Aivoni”</strong>) and any natural or legal
          person who has subscribed an account on the solution published by
          Oliverlist (the <strong>“Client”</strong>).
        </p>
        <p>
          Hereinafter collectively referred to as the <strong>“Parties”</strong> and individually
          referred to as a <strong>“Party”</strong>.
        </p>

        <h2 class="font-weight-bold">1. Definitions</h2>
        <p>
          The terms and expressions which first letter is a capital one, in the
          General Conditions, have the meaning defined in this article, used
          either as singular or plural:
        </p>
        <p>
        <ol>
          <li>
            <span class="number">1.</span>
            <strong>“Authorized Users”</strong> shall mean the identified user, a natural person
            authorized to access Oliverlist. The Authorized User may be an
            employee, agent and/or service provider of the Client.
          </li>
          <li>
            <span class="number">2.</span>
            <strong>“Client Data”</strong> shall mean the data relating to the Client’s prospects
            and client obtained via Oliverlist on the basis of the information
            provided by the Client.
          </li>
          <li>
            <span class="number">3.</span>
            <strong>“Confidential Information”</strong> shall mean any information communicated
            (written, orally or by any other mean) directly or indirectly by the
            Client to Aivoni prior or after the General Conditions’ entry into
            force including, without limitations, the information related to the
            Services as well as the operations, processes, plans, know-how,
            commercial secrets, inventions, techniques, commercial
            opportunities, and activities of the Client.
          </li>
          <li>
            <span class="number">4.</span>
            <strong>“Commission”</strong> shall mean the the sums due by the Client to Aivoni as
            specified in the Campaign with respect to Services relating to actual
            appointments between the Client and its prospects as generated
            through Oliverlist.
          </li>
          <li>
            <span class="number">5.</span>
            <strong>“Force Majeure”</strong> shall mean the events external to the Parties,
            unpredictable and unstoppable, as defined by French case law, the
            following events shall be deemed to constitute a case of Force
            Majeure (without purporting to be an exhaustive list): war (declared
            or not); terrorist act; invasion; rebellion; blockade; sabotage or
            act of vandalism; strike or social dispute, total or partial,
            external to both Parties; bad weather (in particular flooding,
            storms and hurricanes); events declared as “natural disasters”;
            zombie invasion; fire; epidemic; transport or supply blockades
            (particularly energy); failure of electrical energy, heating, air
            conditioning supplies, of the telecommunication or data transport
            network; satellite failure.
          </li>
          <li>
            <span class="number">6.</span>
            <strong>“General Terms of Use”</strong> shall mean the operating manuals, user
            instructions, technical literature, and all other documents
            regarding the use of Oliverlist, in any form, provided to the Client
            by Aivoni under the General Conditions available at this
            https://www.oliverlist.com/oliverlist-general-terms-of-use.
          </li>
          <li>
            <span class="number">7.</span>
            <strong>“Licence Fee”</strong> shall mean the sums due by the Client to Aivoni as
            specified in the Campaign with respect to Services relating to the
            Client Data.
          </li>
          <li>
            <span class="number">8.</span>
            <strong>"Oliverlist" refers to the "software solution"</strong> developed and published by Aivoni 
            that enables the collection of Customer Data.
          </li>
          <li>
            <span class="number">9.</span>
            <strong>“Campaign”</strong> shall mean the Services proposal submitted by Aivoni and
            accepted by the Client, through Oliverlist.
          </li>
          <li>
            <span class="number">10.</span>
            <strong>“Services”</strong> shall mean the services provided by Oliverlist, as
            specified in the Campaign, relating to lead generation leading to B2B
            appointments with Client’s prospects and/or additional features
            relating to the Client Data.
          </li>
        </ol>
        </p>
      </div>
      <div class="pdf-page-break">
        <p>
          <ol>
          <li>
            <span class="number">11.</span>
            <strong>"Platform Fee"</strong>: a fixed monthly amount that guarantees access to 
            all Services, including ConnectPulse™ and the provision of Business Developers.
          </li>
          <li>
            <span class="number">12.</span>
            <strong>"Success Rate"</strong>: Former term "Commission" (keep the old definition, 
            but change the name).
          </li>
          <li>
            <span class="number">13.</span>
            <strong>"Business Promoter"</strong>: a natural person who operates the calls 
            and controls them through the Platform.
          </li>
          <li>
            <span class="number">14.</span>
            <strong>ConnectPulse™</strong>: AI transcription and live coaching module.
          </li>
          <li>
            <span class="number">15.</span>
            <strong>"ReachRadar™"</strong>: AI module for reachability prioritization.
          </li>
          </ol>
        </p>
        <h2 class="font-weight-bold">2. Purpose</h2>
        <p>
          The purpose of the General Conditions is to define the terms and conditions 
          under which Aivoni, in exchange for payment of the Platform Fee and, where applicable, 
          the Success Fee, grants the Client the right to use Oliverlist.
        </p>

        <h2 class="font-weight-bold">3. Duration</h2>
        <p>
          The general terms and conditions become effective on the date the first 
          campaign is signed and are valid for an indefinite period.
        </p>
        <p>
          The Client may terminate the Campaign by sending a request to their Account Manager. 
          Campaigns will be terminated at the end of the current calendar month. Either Party may 
          terminate the contract by giving one (1) month's notice; the Platform Fee for the month 
          in progress will remain payable.
        </p>

        <h2 class="font-weight-bold">4. Access and use of Oliverlist</h2>
        <h3 class="font-weight-bold">1. Initialisation of Oliverlist</h3>
        <p>
          In campaign to register with Oliverlist, the Client must fill in the
          fields of the registration form with complete and accurate data and
          accept the General Conditions.
        </p>
        <p>
          The information provided by the Client is used to create the Client’s
          main user account on Oliverlist. During this phase of creating the
          main account, the Client chooses the login and the password that will
          be attached to it. When choosing passwords, Aivoni advises the Client
          to respect the recommendation of the French National Commission for
          Information Technology and Civil Liberties (CNIL) on passwords in
          campaign to guarantee a minimum level of security (at least twelve
          characters and four different types: lower case, upper case, numbers
          and special characters).
        </p>
        <p>
          In the event of an incomplete or erroneous declaration, the Client’s
          and Authorized Users’ accounts may be closed, ipso jure, without prior
          notice or formality. When the Client is an individual, he/she declares 
          and guarantees that he/she is using Oliverlist for his/her professional 
          activity and that, as such, he/she cannot be qualified as a consumer 
          in the sense of the preliminary article of the French Consumer Code
        </p>
        <p>
        </p>
                <h3 class="font-weight-bold">2. Authorized Users</h3>
        <p>
          The Client undertakes that Authorized Users must be competent individuals, 
          familiar with the use of IT tools, online marketing professionals, and informed 
          by the Client of all matters relating to the processing of personal data and its 
          use in advertising and/or communications activities.
        </p>



      </div>
      <div class="pdf-page-break">
        <h3 class="font-weight-bold">3. Login/password of the Authorized Users</h3>
        <p>
          The Client acknowledges and accepts that it is not possible to access
          Oliverlist without entering a login and password. The Client is solely
          responsible for the security of the logins and passwords provided by
          Aivoni. The Client undertakes to inform Aivoni promptly of any
          unauthorized access, whether actual or suspected, to a login, password
          at the address contact@oliverlist.com
        </p>

        <p>
          Any action performed via a login assigned to the Client will be deemed
          to have been performed by the Client, unless the Client has previously
          reported the login concerned as lost or stolen, thus allowing Aivoni a
          reasonable period of time to deactivate the said login. In this
          context, the Client is responsible for the compliance of each of its
          Authorized Users with the General Conditions.
        </p>
                <h3 class="font-weight-bold">4. Provision of business promoters</h3>
        <p>
          The Client undertakes that Authorized Users must be competent individuals, 
          familiar with the use of IT tools, online marketing professionals, and informed 
          by the Client of all matters relating to the processing of personal data and its 
          use in advertising and/or communications activities.
        </p>
        <h2 class="font-weight-bold">5. Description of the Services</h2>

        <h3 class="font-weight-bold">1. Access to the Services</h3>

        <p>
          Oliverlist is a software solution that allows to search and obtain
          company data of the prospects and/or clients of the Client in order to
          allow it to create targeting campaigns.
        </p>
        <p>
          The Client shall not share any of the accesses of an Authorized User
          with a third party. In this context, the Client is responsible for the
          respect of the General Conditions by each of its Authorized Users.
        </p>
        <p>
          The Client acknowledges having carefully read the General Terms of Use available at 
           this URL (https://www.oliverlist.com/oliverlist-general-terms-of-use) and agrees to 
           abide by them. <strong>Email campaigns, BizDev outbound calls, ConnectPulse™, and ReachRadar™</strong> are 
           an integral part of the Services.    
        </p>
        <h3 class="font-weight-bold">2. Right to Use Oliverlist – Intellectual Property</h3>
        <p>
          Aivoni, in consideration for the payment of the License Fee, grants
          the Client and the Authorized Users, for the term of the General
          Conditions, the non-exclusive, personal, non-transferable right to use
          Oliverlist in accordance with the General Conditions.
        </p>
        <p>
          The Client is responsible for the compliance of the Users with the
          General Conditions and may not transfer the licence in any way
          whatsoever without the prior consent of Aivoni.
        </p>
        <p>
          According to the right of use of Oliverlist, the Client and the
          Authorized Users are expressly prohibited to:
        </p>
        <p>
          <ol>
          <li>
            <span class="number">1.</span>analyse, or have a third party
            analyse, in the sense of observing, studying, and testing, the
            operation of Oliverlist with a view to identifying the ideas and
            principles on which the elements of the program are based when
            Oliverlist is carrying out the tasks of loading, displaying,
            operating, transmitting or storing;
          </li>
          <li>
            <span class="number">2.</span>in the situation where it would have
            had access to the source code for any reason whatsoever, make use of
            the said source code in any way whatsoever with the exception of the
            right granted by article L. 122-6-1 of the French Intellectual
            Property Code any interaction of Aivoni in this respect being
            subject to payment by this latter of the associated costs;
          </li>
          </ol>
        </p>

      </div>
      <div class="pdf-page-break">
        <p>
        <ol>
          <li>
            <span class="number">3.</span>modify, improve, translate
            Oliverlist, including for the purposes of correcting bugs and
            errors, Aivoni exclusively reserving this right in accordance with
            article L. 122-6-1 I 2° of the French Intellectual Property Code;
          </li>
          <li>
            <span class="number">4.</span>transfer, let, sub-let, sell, pledge,
            or transfer all or part of the title to Oliverlist in any way
            whatsoever;
          </li>
          <li>
            <span class="number">5.</span>not provide services through
            Oliverlist to any third party – other than a User – in any manner,
            including but not limited to service bureau, application service
            providing (ASP), software as a service (SaaS) or outsourcing.
          </li>
        </ol>
        </p>
        <h3 class="font-weight-bold">3. Technical knowledge</h3>

        <p>
          Any ideas, know-how, or techniques that Aivoni may develop, including 
          improvements or modifications to Aivoni's software, are the exclusive property 
          of Aivoni. Aivoni may, at its sole discretion, develop, use, market, and 
          license any data processing software or hardware that is similar or related 
          to Aivoni's developments for the Client. Aivoni is not obligated to disclose 
          any ideas, know-how, or techniques it may develop that it considers proprietary 
          and confidential.
        </p>
        <h2 class="font-weight-bold">6. Financial Conditions</h2>

        <h3 class="font-weight-bold">1. License and commissions</h3>
        <p>
          Access to Oliverlist is subject to the Client providing a valid payment method, as 
          defined in the General Terms of Use. In exchange for using Oliverlist, the Client 
          must pay Aivoni the Commission (or Success Fee) and the License Fee (or <strong>Platform Fee</strong>), 
          payable monthly in advance. The Commission is calculated based on the number of appointments 
          scheduled by the Client through Oliverlist under the conditions specified in the General 
          Terms of Use. The <strong>license fee</strong> is determined at the time of subscription to the relevant 
          Service through Oliverlist. No-shows do not generate any commission, but the license 
          fee remains due.
        </p>
        <h3 class="font-weight-bold">2. Payment terms</h3>

        <p>
          For the provision of the Services, (i) the License Fee is payable in advance 
          on a monthly basis; and (ii) the Commission is invoiced and due as soon as an 
          appointment is deemed effective and is paid in accordance with the terms set 
          forth in the General Terms of Use. The fee and/or commission do not include taxes, 
          customs duties, tariffs, value-added tax, or any other applicable taxes, which 
          must be paid additionally by the Client:
        </p>
        <p>
          <ol>
            <li>
              <span class="number">1.</span>Any outstanding amount will automatically accrue interest, 
              which will accrue daily until the date of full payment of principal, interest, fees 
              and additional costs, at a rate equal to five (5) times the applicable legal interest rate,
               without the need for any other formal notification and without prejudice to any claim for 
               compensation that Aivoni reserves the right to request through judicial means;
            </li>
            <li>
              <span class="number">2.</span>Aivoni reserves the right, at its
              sole discretion, with or without notice, to suspend performance of
              any Service, current or future, and this until full payment of
              outstanding sums;
            </li>
            <li>
              <span class="number">3.</span>Any delay in the payment of invoices
              will result in the immediate application of an annual interest rate
              of 12% on the unpaid amounts as well as forty (40) euros per invoice
              for collection costs, in accordance with art. L 4414-10 of the
              French Commercial Code; and
            </li>
            <li>
              <span class="number">4.</span>all sums that remain due for payment
              by the Client to Aivoni shall become immediately payable.
            </li>
            <li>
              <span class="number">5.</span>Late fees apply to both the 
              License and Commissions.
            </li>
          </ol>
        </p>
        <p>
          Oliverlist uses zero-value pre-authorization technology. This means
          that the customer must enter a valid payment method and approve the
          zero-value pre-authorization to validate the payment method. By doing
          so, the customer authorizes AIVONI to debit his/her payment method for
          valid appointments, in accordance with the terms described
          in Oliverlist's General Terms and Conditions of Use.
        </p>

      </div>
      <div class="pdf-page-break">
        <h2 class="font-weight-bold">7. Undertakings of Aivoni</h2>
        <p>
          The Services will be provided under the General Conditions by Aivoni,
          which undertakes, unless otherwise expressly stated, to exercise its
          reasonable endeavours.
        </p>
        <p>
          Unless otherwise expressly stipulated, Aivoni’s obligations under the
          General Conditions are obligations of means.
        </p>
        <p>
          Aivoni is committed to ensuring that all its staff apply their
          know-how and knowledge to the proper execution of Services. In the
          event of difficulties in the provision of Services, Aivoni undertakes
          to inform the Client immediately.
        </p>
        <p>
          Aivoni reserves the right to modify at any time the characteristics of
          its technical infrastructures, the choice of its technical suppliers
          and the composition of its teams.
        </p>
        <p>
          Aivoni is not responsible if KPIs are not met for reasons beyond its control 
          (inaccurate ICP, lack of authorized call time slots, client refusal to validate 
          email sequences, etc.).
        </p>
        <h2 class="font-weight-bold">8. Undertakings of the Client</h2>
        <p>The Client shall:</p>
        <p>
          <ol>
                        <li>
              <span class="number">1.</span>strictly comply with the user
              instructions set forth in the General Terms of Use;
            </li>
            <li>
              <span class="number">2.</span>not to import into Oliverlist any
              data that may damage Oliverlist and/or infringe the rights of any
              third party;
            </li>
            <li>
              <span class="number">3.</span>have an up-to-date Internet browser,
              as well as a high-speed Internet connection, the costs of which are
              to be borne by them
            </li>
            <li>
              <span class="number">4.</span>to make backups of all its data,
              prior to the first use of Oliverlist and each time it deems
              necessary. Aivoni can in no way be held responsible for any loss of
              data suffered by the Client;
            </li>
            <li>
              <span class="number">5.</span>not to take any action to damage the 
              reputation of Oliverlist or Aivoni, the trademarks of Aivoni or its 
              licensors or any other product of Aivoni or its licensors;
            </li>
            <li>
              <span class="number">6.</span>use the Aivoni name and trademarks
              only in the manner prescribed by Aivoni in writing, unless otherwise
              agreed between Parties upon writing;
            </li>
            <li>
              <span class="number">7.</span>inform Aivoni of any potential
              defects discovered when using Oliverlist;
            </li>
            <li>
              <span class="number">8.</span>promptly notify Aivoni of any legal notice, 
              claim or action directly or indirectly related to Oliverlist and not to 
              initiate or commit any legal action or other procedure related to Oliverlist
              without Aivoni's prior written consent;
            </li>
            <li>
              <span class="number">9.</span>use Oliverlist for illegal purposes
              or in illegal manner, including in violation of the intellectual
              property rights of Aivoni or any third party.
            </li>
          </ol>
        </p>
        <h2 class="font-weight-bold">9. Confidentiality</h2>
        <h3 class="font-weight-bold">1. Confidential Information</h3>
        <p>Confidential Information does not include:</p>
        <p>
          <ol>
            <li>
              <span class="number">1.</span>Information that is currently
              available or that becomes available to the public without either
              Party breaching the General Conditions;
            </li>
            <li>
              <span class="number">2.</span>Information legally held by one Party
              before its disclosure by the other;
            </li>
            <li>
              <span class="number">3.</span>Information that does not come
              either directly or indirectly from the use of all or part of the
              Confidential Information;
            </li>
            <li>
              <span class="number">4.</span>Information validly obtained from a
              third Party authorized to transfer or disclose such information.
            </li>
          </ol>
        </p>
      </div>
      <div class="pdf-page-break">
        <h3 class="font-weight-bold">2. Confidentiality Undertaking</h3>
        <p>
          The Client undertakes, in its name and in the name of its employees,
          agents, sub-contractors and Clients, for the duration of the General
          Conditions and for a period of five (5) years after the end of the
          General Conditions:
        </p>
                <p>
          <ol>
            <li>
              <span class="number">1.</span>Not to use the Confidential
              Information for any purpose other than the performance of its
              obligations under the General Conditions;
            </li>
            <li>
              <span class="number">2.</span>To take all precautions that it would
              take with its own valuable confidential information, it being stated
              that such precautions must not be less than those of a diligent
              professional;
            </li>
            <li>
              <span class="number">3.</span>Not to disclose the Confidential
              Information to anybody whatsoever, by any means whatsoever, except
              to those of its employees, agents, service providers or
              sub-contractors for whom such information is necessary with a view
              to meeting the obligations of each of the Parties.
            </li>
          </ol>
        </p>
                <p>
          When the General Conditions comes to an end, each Party shall return
          to the other Party, without delay, all Confidential Information,
          regardless of format, that it has obtained within the scope of the
          General Conditions.
        </p>
        <p>
          Neither Party shall keep any copies in any format whatsoever, without
          the express prior written agreement of Aivoni.
        </p>
        <h2 class="font-weight-bold">10. Data protection</h2>

        <h3 class="font-weight-bold">1. Processing of Client Data</h3>
        <p>
          Within the framework of the execution of the General Conditions, 
          Aivoni may process, among other things, personal data on behalf of and 
          for the account of the Client.
        </p>
        <p>
          Consequently, Aivoni acts as a subcontractor, with the Client being responsible 
          for the collection and processing of this personal data.
        </p>
        <p>
          The Parties entered into a contract in accordance with the provisions
          of Article 28 of the Regulations (EU) 2016/679 on the protection of
          natural persons with regard to the processing of personal data and on
          the free movement of such data (the <strong>“GDPR”</strong>) as set out in Appendix A.
        </p>
        <h3 class="font-weight-bold">2. Data processing by Aivoni</h3>
        <p>
          In addition, in its dealings with the Client, Aivoni may process, on its 
          own behalf, the personal data of the Client's employees, directors, subcontractors, 
          agents and/or service providers.
        </p>
        <p>
          In this context, the Client’s staff have the right to access and, if
          necessary, rectify, delete or transfer data concerning them. They also
          have the right to define guidelines on the fate of their personal data
          after their death.
        </p>
        <p>
          In addition, the Client’s staff may object for legitimate reasons to
          the processing of personal data concerning them, withdraw their
          consent or even limit it.
        </p>
        <p>
          These rights can be exercised at any time by writing to Aivoni at the
          following address, contact@oliverlist.com.
        </p>
        <p>
          The Client’s staff have the possibility to lodge a complaint with a
          supervisory authority.
        </p>
        <p>
          The Client undertakes to inform its employees, managers,
          subcontractors, agents and/or service providers of these rights.
        </p>
        <p>
          Aivoni will keep the personal data of the Client’s employees,
          managers, subcontractors, agents and/or service providers for a period
          of three (3) years from the expiry of the General Conditions.
        </p>
      </div>
      <div class="pdf-page-break">
        <p>
          Aivoni will process the said personal data on its exclusive behalf
          within the framework of the General Conditions and will refrain from
          communicating them to a third party.
        </p>
        <p>
          The Client obtains all legal authorizations to transcribe calls.
        </p>
        <p>
          Aivoni continues to act as a subcontractor for this new data 
          (recordings, transcriptions).
        </p>
        <h2 class="font-weight-bold">11. Reversibility</h2>
        <p>
          Within forty-five (45) days from the expiration of the Campaign, the 
          Client may export the Client Data under the conditions defined in this article 11.
        </p>
        <p>
          At the end of this reversibility period, Aivoni will proceed to the
          complete deletion of the personal data contained in the Client Data,
          with the exception of anonymous statistical data collected by
          Oliverlist in the context of the provision of services to the Client.
        </p>
        <h2 class="font-weight-bold">12. Liability</h2>
        <p>
          Aivoni will use its best efforts to ensure that Oliverlist complies
          with the provisions of the General Terms of Use. Any warranty other
          than the ones set forth under the General Conditions is expressly
          excluded by Aivoni.
        </p>
        <p>
          Specifically, Aivoni does not warrant the absence of any bugs, and as
          a consequence does not warrant that the use of Oliverlist will be
          uninterrupted and error free. Aivoni hereby expressly disclaims the
          French legal warranty on hidden defects (“<em>garantie des vices cachés</em>”)
          set for in article 1641 and seq. of the French Civil Code.
        </p>
        <p>
          The Client acknowledges having a good understanding of the Internet
          and of its limitations. The Client agrees notably, but without
          limitation, that the transmissions on the Internet are not secured and
          can be delayed, lost, intercepted, or corrupted, and that the
          transmission of Confidential Information on the Internet is made by
          the Client at its own risks.
        </p>
        <p>
          The Parties expressly agree that the provisions of this Article have
          been agreed between the Parties within the scope of an all-reaching
          negotiation process, such that each of the Parties deems them to be
          both justified and proportionate with reference to the other
          undertakings made under the General Conditions.
        </p>
        <p>
          Aivoni shall only be held liable for direct and foreseeable damage
          within the meaning of articles 1231-3 and 1231-4 of the French Civil
          Code caused by the failure of Aivoni to meet its obligations under the
          General Conditions.
        </p>
        <p>
          The Parties expressly agree that Aivoni shall not be held liable for
          any loss of revenue; loss of turnover or profit; loss of clients; loss
          of opportunity; loss in terms of image or reputation; any costs
          incurred in obtaining an alternative product, software, service, or
          technology; or for any technical difficulties in routing messages via
          Internet.
        </p>
        <p>
          Aivoni shall not be held liable for any damage resulting from the
          destruction of files or data caused by the Client using one or more
          elements provided with Oliverlist.
        </p>
        <p>
          If Aivoni should be campaigned to pay a financial penalty, for any reason
          whatsoever, the amount of compensation awarded against it shall not
          exceed the total amount received by Aivoni in payments over the twelve
          (12) months preceding the claim.
        </p>
        <p>
          In any case, the Client must bring a claim against Aivoni for breach
          of the General Conditions within a period of twelve (12) months from
          the date of such breach, which the Client hereby expressly
          acknowledges and accepts. Aivoni shall under no circumstances be held
          liable for any damage caused by the failure of the Client to meet its
          own obligations.
        </p>
      </div>
      <div class="pdf-page-break">
        <h2 class="font-weight-bold">13. Termination</h2>
        <p>
          Each Party has the right, without prejudice to any claims for
          compensation that it reserves the right to seek through legal means,
          to terminate the General Conditions and/or the Campaign with immediate
          effect in case of a material breach by the other Party of any of its
          essential obligations under the General Conditions, if the Party in
          breach fails to remedy such breach within thirty (30) working days of
          receiving notice of the breach from the other Party in writing sent by
          registered mail with acknowledgement of receipt.
        </p>
        <p>
          In the event of termination of an Campaign for any reason, Client shall
          immediately cease use of any item provided as part of the Services
          under such Campaign.
        </p>
        <h2 class="font-weight-bold">14. Miscellaneous</h2>
        <h3 class="font-weight-bold">1. Assignment/transfer of the General Conditions</h3>
        <p>
          Aivoni shall have the right to transfer all or part of its rights and obligations 
          under these Terms and Conditions to any third party of its choosing, including any 
          subsidiary that may be established and/or in the event of a merger, spin-off, partial 
          asset transfer, or the sale of all or part of its business.
        </p>
        <p>
          It is expressly agreed between the Parties that any change in the
          capital structure of Aivoni, including a change of control, shall not
          affect the performance of the General Conditions.
        </p>
    
        <p>
          The Client is not authorized to transfer all or part of its
          obligations under the General Conditions, in any manner whatsoever,
          without the prior, written, and express consent of Aivoni.
        </p>
        <h3 class="font-weight-bold">2. Communication – Publicity</h3>
        <p>
          The Client accepts to be featured on Aivoni™s clients reference list.
          Such acceptance includes being mentioned in press releases or project
          accounts, and the fact that the General Conditions may be used as an
          example of a mutually beneficial collaboration for marketing purposes.
        </p>
        <h3 class="font-weight-bold">3. Notification - Calculation of deadlines</h3>
        <p>
          Any notification required or necessary pursuant to the provisions of
          the General Conditions shall be in writing and shall be deemed validly
          given if sent via e-mail to Aivoni at contact@oliverlist.com
        </p>

        <p>
          Unless otherwise specified in an article of the General Conditions,
          the deadlines are calculated per calendar day. Any period calculated
          from a notification shall run from the first attempt to deliver it to
          the addressee, the postmark being proof.
        </p>
        <h3 class="font-weight-bold">4. Force Majeurea</h3>
        <p>
          Neither Party shall be held liable if the performance of its
          obligations should be delayed, restricted, or made impossible by
          virtue of a case of Force Majeure.
        </p>
        <p>
          If a case of Force Majeure should occur, the performance of the
          obligations of each Party shall be suspended.
        </p>
        <p>
          If the Force Majeure should last for more than one (1) month the
          General Conditions may be terminated at the request of the most
          diligent of the Parties, with neither Party being held liable. Each of
          the Parties shall bear their own costs that may be incurred as a
          result of the Force Majeure.
        </p>
      </div>
      <div class="pdf-page-break">
        <h3 class="font-weight-bold">5. Suppliers – Contractors – Subcontractors</h3>
        <p>
          Throughout the duration of the General Conditions, Aivoni shall be
          free to use any supplier, service provider and/or subcontractor of its
          choice.
        </p>
        <p>
          In this context, Aivoni remain, under the conditions set out in the
          General Conditions, responsible for the provision of the services.
        </p>

        <h3 class="font-weight-bold">6. Evidence</h3>
        <p>
          The computerized records will be kept in Aivoni™s computer systems
          under reasonable security conditions and will be considered as proof
          of the exchanges and/or actions carried out by Users, which the Client
          declares that it accepts.
        </p>
        <h3 class="font-weight-bold">7. Waiver</h3>
        <p>
          If one or other Party should fail to exercise any one of its rights
          under the General Conditions whatsoever, this shall not be deemed to
          be a waiver of that right, such waiver only to be deemed to have been
          given when expressly declared by the Party in question.
        </p>
        <h3 class="font-weight-bold">8. Entirety</h3>
        <p>
          The General Conditions constitute the entire agreement between the
          Parties, to the exclusion of any other document, in particular those
          that may be issued by the Client before or after the Client™s
          acceptance of the General Conditions.
        </p>
      
        <h3 class="font-weight-bold">9. Validity</h3>
        <p>
          If one or more of the provisions of the General Conditions should be
          held to be invalid by a competent court, the remaining provisions
          shall retain their scope and effect.
        </p>
        <p>
          The provision that has been held to be invalid shall be replaced by
          another provision, the scope and meaning of which shall be as close as
          possible to the scope and meaning of the invalidated provision, but in
          compliance with applicable legislation and the mutual intent of the
          Parties.
        </p>
        <h3 class="font-weight-bold">10. Change of the General Conditions</h3>
        <p>
          Aivoni reserves the right to make, at any time, any change it deems
          necessary and useful to the General Conditions.
        </p>
        <p>
          In the event of a change in the General Conditions, Aivoni undertakes
          to make the Client accept the new general conditions, fifteen (15)
          days before the date of their entry into force.
        </p>

        <h2 class="font-weight-bold">15. Applicable Law- Competent jurisdiction</h2>
        <p>The General Conditions are governed by French Law.</p>
        <p>
          The Parties expressly accept to submit any dispute related to the
          General Conditions (understood as any dispute related to its
          negotiation, conclusion, enforcement, cancellation and/or termination)
          and/or related to the commercial relationships between the Parties and
          their termination, to the exclusive competence of the Paris Courts,
          notwithstanding plurality of defendants or warranty claims, and
          including summary proceedings and <em>ex parte</em> motions.
        </p>
      </div>
      <div class="pdf-page-break">
        <h4 class="font-weight-bold">Appendix A</h4>
        <h2 class="text-venter font-weight-bold">Subcontracting Agreement</h2>
        <p>
          For all intents and purposes, all terms used in this appendix whose
          first letter of each word is in capital letter have the same meaning
          as in the Aivoni General Conditions.
        </p>
        <h3 class="font-weight-bold">1. Purpose of these clauses</h3>
        <p>
          Aivoni is required to process personal data in the context of the 
          execution of the General Conditions, including customer data.
        </p>
        <p>
          Aivoni (the <strong>“Processor”</strong>) acts as a subcontractor, the Client (the
          <strong>“Controller”</strong>) being responsible for the collection and processing of
          such personal data.
        </p>
        <p>
          The purpose of these clauses is to define the conditions under which 
          the data processor undertakes to process the personal data defined below 
          on behalf of the data controller.
        </p>
        <p>
          In the context of their contractual relationship, the Parties
          undertake to comply with the regulations in force applicable to the
          processing of personal data and, in particular, Regulation (EU)
          2016/679 on the protection of natural persons with regard to the
          processing of personal data and on the free movement of such data (the
          <strong>“GDPR”</strong>).
        </p>
        <h3 class="font-weight-bold">2. Description of the subcontracted personal data processing</h3>
        <p>
          The data processor is authorized to process, on behalf of the data controller, 
          the personal data necessary to provide the service(s).
        </p>
        <p>
          The categories of persons affected are the end users of the services provided 
          by the Client and the users authorized to access Oliverlist by the Client.
        </p>
        <p>The purposes of the processing are as follows:</p>
        <p>
          <ol>
            <li><span class="number">1.</span>to provide Services;</li>
            <li>
              <span class="number">2.</span>to provide management services used
              by the Client;
            </li>
            <li><span class="number">3.</span>for statistical purposes;</li>
            <li>
              <span class="number">4.</span>to comply with applicable
              legislation;
            </li>
            <li>
              <span class="number">5.</span>to manage the Client relationship;
            </li>
            <li><span class="number">6.</span>to prevent fraud;</li>
            <li>
              <span class="number">7.</span>to manage requests from data
              subjects for exercising their rights such as the right of access,
              rectification, deletion, opposition, erasure, limitation,
              portability, and concerning the use of personal data after the death
              of data subjects.
            </li>
          </ol>
        </p>
        <p>
          Unless the consent of the data subjects obtained under the conditions
          provided in accordance with the applicable legislation, these
          operations must not lead to the creation of profiles that may reveal
          sensitive data (racial or ethnic origins, philosophical, political,
          trade union, or religious opinions, sexual life or people™s health).
        </p>
        <p>
          In any event, the Controller is required to previously inform the
          Processor of any other processing intended and to guarantee compliance
          with the applicable regulation. In particular, the Controller is
          required to carry out, if necessary, a data protection impact
          assessment of the processing intended under the conditions defined in
          Article 35 of the GDPR.
        </p>

        <p>
          The personal data processed is or may be as follows, if necessary, in
          view of the purpose of the processing in question:
        </p>
        <p>
        <ol>
          <li>1. identity (name, postal address);</li>
     
          <li>2. data related to the profession;</li>
        </ol>
        </p>
      </div>
      <div class="pdf-page-break">
                <p>
          For the performance of the Service subject of the General Conditions,
          the Controller shall make available to the Processor the information
          which guarantees compliance with the legal provisions in force and in
          particular the GDPR.
        </p>
        <h3 class="font-weight-bold">3. Duration of these clauses</h3>
        <p>
          These clauses will take effect from the date of entry into force of the 
          General Conditions and during the period of validity thereof.
        </p>
        <h3 class="font-weight-bold">4. Undertakings of the Controller</h3>
        <p>
          The Controller undertakes, in the context of the performance of the
          General Conditions to:
        </p>
        <p>
          <ol>
            <li>
              <span class="number">1.</span>transmit via the Oliverlist only
              Client Data strictly necessary for the provision of the Services;
            </li>
            <li>
              <span class="number">2.</span>document in writing any instructions
              regarding the processing of personal data by the Processor;
            </li>
            <li>
              <span class="number">3.</span>comply with the provisions of the
              French law n°78-17 on Information Technology and Freedoms, the GDPR
              and more generally the regulations applicable in France;
            </li>
            <li>
              <span class="number">4.</span>supervise the processing of personal
              data, including through the conducting of audits in accordance with
              the terms previously agreed with the Processor;
            </li>
            <li>
              <span class="number">5.</span>ensure that there is a legal basis for
              the processing of personal data;
            </li>
            <li>
              <span class="number">6.</span>obtain, where applicable, the consent
              of the data subjects to the processing and/or transfer of their
              personal data;
            </li>
            <li>
              <span class="number">7.</span>provide all relevant information to
              data subjects at the time of data collection.
            </li>
          </ol>
        </p>
        <p>
          The Processor shall not be liable for any failure by the Controller to
          comply with applicable regulation except where the law expressly
          provides otherwise.
        </p>
        <h3 class="font-weight-bold">5. Undertakings of the Processor</h3>
        <p>
          In accordance with Articles 28 and 32 of the GDPR, the processor
          undertakes:
        </p>
        <p>
          <ol>
            <li>
              <span class="number">1.</span>to take and maintain all useful
              measures, and in particular appropriate technical and organizational
              measures, to preserve the security and confidentiality of the
              personal data entrusted to it by the Controller for the provision of
              the Services, in order to prevent them from being distorted,
              altered, damaged, or accessed by unauthorized persons;
            </li>
            <li>
              <span class="number">2.</span>to ensure that persons authorized to
              process personal data on their behalf, in addition to having
              received the necessary training in the protection of personal data,
              respect confidentiality or are subject to an appropriate legal
              obligation of confidentiality;
            </li>
            <li>
              <span class="number">3.</span>to comply with applicable legal
              provisions relating to the conditions of processing and/or the
              destination of the data provided by the Controller or which it will
              have access to in the context of the provision of Services;
            </li>
            <li>
              <span class="number">4.</span>to act only on the only documented
              instruction of the Controller for the processing of the personal
              data in question;
            </li>
            <li>
              <span class="number">5.</span>to use the personal data collected or
              to which it may have access solely for the purposes of providing the
              Controller with the Services;
            </li>
            <li>
              <span class="number">6.</span>not to use the personal data
              collected or which it may have access in the context of the
              performance of the Contract for purposes contrary to the Contract in
              accordance with the applicable regulations, and to transfer it only
              to a third party indicated or authorized by the Controller;
            </li>
            <li>
              <span class="number">7.</span>not to resell or transfer personal
              data that is strictly confidential;
            </li>
            <li>
              <span class="number">8.</span>to assist the Controller, where
              possible, by implementing appropriate technical and organizational
              measures, as well as to fulfil its obligation to respond to requests
              from data subjects in order to exercise their rights of access,
              rectification, erasure, opposition, limitation and portability of
              data;
            </li>
        
            <li>
              <span class="number">9.</span>to assist the Controller, where
              possible and in light of the information provided to it by the
              latter, to comply with its obligation to: (a) notify the supervisory
              authority of a personal data breach; (b) communicate a personal data
              breach to the data subject; (c) conduct a data protection impact
              assessment.
            </li>
          </ol>
        </p>
      </div>
      <div class="pdf-page-break">
                <p>
          The Processor may use another subcontractor to carry out specific
          processing activities. In this case, it shall previously inform the
          Controller in writing of any proposed changes concerning the addition
          or replacement of other subcontractors.
        </p>
        <p>
          The Controller has a minimum of seven (7) days from the date of
          receipt of this information to submit its objections. This
          subcontracting can only be carried out if the Controller has not
          raised any objections within the agreed period.
        </p>
        <p>The list of second-rank subcontractors is available here:</p>
        <p>
          <ol>
            <li>* Apollo.io</li>
            <li>* Total enrichment</li>
            <li>* OpenAI</li>
            <li>* DeepSeek</li>
            <li>* Ringover</li>
          </ol>
        </p>
      </div>

      <!-- FIN INGLES -->
      <!-- FRANCES -->
      <div class="pdf-page-break">
        <div class="table-header">
          <table>
            <tbody>
              <tr>
                <td width="50%">
                  <img src="@/assets/images/logo-h.png" class="pdf-logo" />
                </td>
                <td>
                  <p>{{ user.name }} {{ user.lastname }}</p>
                  <p>Accepté: {{ user.creation_date }}</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h1><span>Last updated: 09/06/2025</span> TERMES ET CONDITIONS</h1>
        <p>
          Ces conditions générales d'Oliverlist (la <strong>“Conditions générales”</strong>)
          régir la relation entre <strong>Aivoni</strong>, a société, par actions
          simplifiée, immatriculée au Registre du Commerce et des Sociétés de Nanterre sous le 
          numéro 808 785 166, au capital social de 20 000 euros, dont le siège social est situé au 4, 
          avenue JB Clément, 92100 Boulogne-Billancourt, France. (<strong>“Aivoni”</strong>) et
          toute personne physique ou morale ayant souscrit un compte sur la solution éditée par   
          Oliverlist (la <strong>"Cliente"</strong>).
        </p>
        <p>
          Ci-après collectivement dénommés le <strong>"Parties"</strong> et individuellement 
          appelé un <strong>"Partie"</strong>.
        </p>

        <h2 class="font-weight-bold">1. Définitions</h2>
        <p>
          Les termes et expressions dont la première lettre est une majuscule, dans les 
          Conditions Générales, ont le sens défini dans le présent article, utilisés au 
          singulier ou au pluriel :
        </p>
        <p>
        <ol>
          <li>
            <span class="number">1.</span>
            <strong>“Utilisateurs autorisés”</strong> désigne l'utilisateur identifié, 
            une personne physique autorisée à accéder à Oliverlist. L'utilisateur autorisé 
            peut être un employé, un agent et/ou un prestataire de services du Client.
          </li>
          <li>
            <span class="number">2.</span>
            <strong>“Données client”</strong> désigne les données relatives aux prospects et 
            clients du Client obtenues via Oliverlist sur la base des informations fournies 
            par le Client.
          </li>
          <li>
            <span class="number">3.</span>
            <strong>“Informations confidentielles”</strong> désigne toute information communiquée 
            (par écrit, oralement ou par tout autre moyen) directement ou indirectement par le Client 
            à Aivoni avant ou après l'entrée en vigueur des Conditions Générales, y compris, sans limitation, 
            les informations relatives aux Services ainsi qu'aux opérations, procédés, plans, savoir-faire, 
            secrets commerciaux, inventions, techniques, opportunités commerciales et activités du Client.
          </li>
          <li>
            <span class="number">4.</span>
            <strong>“Commission”</strong> désigne les sommes dues par le Client à Aivoni, telles que 
            spécifiées dans la Campagne, au titre des Services relatifs aux rendez-vous réels entre le 
            Client et ses prospects, tels que générés via Oliverlist.
          </li>
          <li>
            <span class="number">5.</span>
            <strong>“Force Majeure”</strong> désigne les événements extérieurs aux Parties, imprévisibles et 
            irrésistibles, tels que définis par la jurisprudence française. Seront considérés comme cas de Force 
            Majeure (sans prétendre à une liste exhaustive) : guerre (déclarée ou non) ; acte terroriste ; invasion ; 
            rébellion ; blocus ; sabotage ou acte de vandalisme ; grève ou conflit social, total ou partiel, extérieur 
            aux Parties ; intempéries (notamment inondations, tempêtes et ouragans) ; événements déclarés « catastrophes naturelles » 
            ; invasion de zombies ; incendie ; épidémie ; blocage des transports ou de l’approvisionnement (notamment énergétique) 
            ; panne d’électricité, de chauffage, de climatisation, du réseau de télécommunication ou de transport de données 
            ; panne de satellite.
          </li>
          <li>
            <span class="number">6.</span>
            <strong>“Conditions générales d'utilisation”</strong> désigne les manuels d'utilisation, 
            les instructions d'utilisation, la documentation technique et tous les autres documents 
            relatifs à l'utilisation d'Oliverlist, sous quelque forme que ce soit, fournis au Client par 
            Aivoni conformément aux Conditions générales disponibles sur 
            https://www.oliverlist.com/oliverlist-general-terms-of-use.
          </li>
          <li>
            <span class="number">7.</span>
            <strong>“Licence Fee”</strong> désigne les sommes dues par le Client à Aivoni, telles 
            que spécifiées dans la Campagne, au titre des Services relatifs aux Données Client.
          </li>
          <li>
            <span class="number">8.</span>
            <strong>"Oliverlist" fait référence à la "solution logicielle"</strong> développé et 
            publié par Aivoni qui permet la collecte de données clients.
          </li>
          <li>
            <span class="number">9.</span>
            <strong>"Campagne"</strong> désigne la proposition de Services soumise par Aivoni 
            et acceptée par le Client, via Oliverlist.
          </li>
          <li>
            <span class="number">10.</span>
            <strong>“Services”</strong> désigne les services fournis par Oliverlist, tels que 
            spécifiés dans la Campagne, relatifs à la génération de leads menant à des rendez-vous 
            B2B avec les prospects du Client et/ou à des fonctionnalités supplémentaires relatives 
            aux Données Client.
          </li>
        </ol>
        </p>
      </div>
      <div class="pdf-page-break">
        <p>
          <ol>
          <li>
            <span class="number">11.</span>
            <strong>"Platform Fee"</strong>: un montant mensuel fixe garantissant l'accès à tous 
            les services, y compris ConnectPulse™ et la mise à disposition de développeurs commerciaux.
          </li>
          <li>
            <span class="number">12.</span>
            <strong>"Taux de réussite"</strong>: Ancien terme « Commission » (conserver 
            l’ancienne définition, mais changer le nom).
          </li>
          <li>
            <span class="number">13.</span>
            <strong>"Promoteur d'entreprise"</strong>: une personne physique qui gère les 
            appels et les contrôle via la Plateforme.
          </li>
          <li>
            <span class="number">14.</span>
            <strong>ConnectPulse™</strong>: Module de transcription IA et de coaching en direct.
          </li>
          <li>
            <span class="number">15.</span>
            <strong>"ReachRadar™"</strong>: Module d'IA pour la priorisation de l'accessibilité.
          </li>
          </ol>
        </p>
        <h2 class="font-weight-bold">2. Objectif</h2>
        <p>
          Les présentes Conditions Générales ont pour objet de définir les modalités selon 
          lesquelles Aivoni, en échange du paiement des Frais de Plateforme et, le cas échéant, 
          des Frais de Succès, accorde au Client le droit d'utiliser Oliverlist.
        </p>

        <h2 class="font-weight-bold">3. Durée</h2>
        <p>
          Les conditions générales entrent en vigueur à la date de signature de la 
          première campagne et sont valables pour une durée indéterminée.
        </p>
        <p>
          Le Client peut résilier la Campagne en adressant une demande à son Responsable de Compte. 
          Les campagnes prendront fin à la fin du mois calendaire en cours. Chaque Partie peut résilier 
          le contrat moyennant un préavis d'un (1) mois ; les Frais de Plateforme pour le mois 
          en cours resteront dus.
        </p>

        <h2 class="font-weight-bold">4. Accès et utilisation d'Oliverlist</h2>
        <h3 class="font-weight-bold">1. Initialisation d'Oliverlist</h3>
        <p>
          Pour s'inscrire sur Oliverlist, le Client doit remplir les champs du 
          formulaire d'inscription avec des données complètes et exactes et accepter 
          les Conditions Générales.
        </p>
        <p>
          Les informations fournies par le Client servent à créer son compte utilisateur 
          principal sur Oliverlist. Lors de cette phase de création, le Client choisit l'identifiant 
          et le mot de passe qui lui seront associés. Lors du choix de ses mots de passe, Aivoni 
          conseille au Client de respecter la recommandation de la Commission nationale de 
          l'informatique et des libertés (CNIL) relative aux mots de passe afin de garantir un 
          niveau de sécurité minimal (au moins douze caractères et quatre types différents : 
          minuscules, majuscules, chiffres et caractères spéciaux).
        </p>
        <p>
          En cas de déclaration incomplète ou erronée, les comptes du Client et des Utilisateurs 
          Autorisés pourront être clôturés de plein droit, sans préavis ni formalité. Lorsque le 
          Client est une personne physique, il déclare et garantit qu'il utilise Oliverlist dans 
          le cadre de son activité professionnelle et qu'à ce titre, il ne peut être qualifié de 
          consommateur au sens de l'article préliminaire du Code de la consommation.
        </p>
        <p>
        </p>
                <h3 class="font-weight-bold">2. Utilisateurs autorisés</h3>
        <p>
          Le Client s'engage à ce que les Utilisateurs Autorisés soient des personnes compétentes, 
          familiarisées avec l'utilisation des outils informatiques, des professionnels du marketing 
          en ligne et informées par le Client de toutes les questions relatives au traitement des 
          données personnelles et à leur utilisation dans le cadre d'activités publicitaires et/ou 
          de communication.
        </p>



      </div>
      <div class="pdf-page-break">
        <h3 class="font-weight-bold">3. Identifiant/mot de passe des utilisateurs autorisés</h3>
        <p>
          Le Client reconnaît et accepte qu'il est impossible d'accéder à Oliverlist sans 
          saisir un identifiant et un mot de passe. Le Client est seul responsable de la 
          sécurité des identifiants et mots de passe fournis par Aivoni. Le Client s'engage 
          à informer Aivoni dans les meilleurs délais de tout accès non autorisé, réel ou 
          suspecté, à un identifiant ou un mot de passe à l'adresse contact@oliverlist.com.
        </p>

        <p>
          Toute action effectuée via un identifiant attribué au Client sera réputée avoir été 
          effectuée par le Client, sauf si ce dernier a préalablement signalé la perte ou le vol 
          de l'identifiant concerné, accordant ainsi à Aivoni un délai raisonnable pour le désactiver. 
          Dans ce contexte, le Client est responsable du respect des Conditions Générales par chacun 
          de ses Utilisateurs Autorisés.
        </p>
                <h3 class="font-weight-bold">4. Mise à disposition de promoteurs d'entreprises</h3>
        <p>
          Le Client s'engage à ce que les Utilisateurs Autorisés soient des personnes compétentes, 
          familiarisées avec l'utilisation des outils informatiques, des professionnels du marketing 
          en ligne et informées par le Client de toutes les questions relatives au traitement des données 
          personnelles et à leur utilisation dans le cadre d'activités publicitaires et/ou de communication.
        </p>
        <h2 class="font-weight-bold">5. Description des services</h2>

        <h3 class="font-weight-bold">1. Accès aux Services</h3>

        <p>
          Oliverlist est une solution logicielle permettant de rechercher et d'obtenir des données 
          d'entreprise sur les prospects et/ou clients du Client afin de lui permettre de créer des 
          campagnes de ciblage.
        </p>
        <p>
          Le Client s'interdit de partager les accès d'un Utilisateur Autorisé avec un tiers. À ce titre, 
          le Client est responsable du respect des Conditions Générales par chacun de ses Utilisateurs 
          Autorisés.
        </p>
        <p>
          Le Client reconnaît avoir lu attentivement les Conditions Générales d'Utilisation disponibles 
          à cette adresse (https://www.oliverlist.com/oliverlist-general-terms-of-use) et s'engage à les 
          respecter. <strong>Les campagnes par e-mail, les appels sortants BizDev, ConnectPulse™ et ReachRadar™ </strong>
          font partie intégrante des Services.
        </p>
        <h3 class="font-weight-bold">2. Droit d'utilisation d'Oliverlist – Propriété intellectuelle</h3>
        <p>
          Aivoni, en contrepartie du paiement des frais de licence, accorde au Client et aux Utilisateurs 
          autorisés, pour la durée des Conditions générales, le droit non exclusif, personnel et non 
          transférable d'utiliser Oliverlist conformément aux Conditions générales.
        </p>
        <p>
          Le Client est responsable du respect des Conditions Générales par les Utilisateurs et ne 
          peut en aucun cas transférer la licence sans le consentement préalable d'Aivoni.
        </p>
        <p>
          Conformément au droit d'utilisation d'Oliverlist, il est expressément interdit 
          au Client et aux Utilisateurs autorisés de :
        </p>
        <p>
          <ol>
          <li>
            <span class="number">1.</span>analyser, ou faire analyser par un tiers, au sens d'observer, 
            d'étudier et de tester, le fonctionnement d'Oliverlist en vue d'identifier les idées et 
            les principes sur lesquels reposent les éléments du programme lorsque Oliverlist exécute 
            les tâches de chargement, d'affichage, d'exploitation, de transmission ou de stockage ;
          </li>
          <li>
            <span class="number">2.</span>dans l'hypothèse où elle aurait eu accès au code source pour 
            quelque raison que ce soit, faire usage dudit code source de quelque manière que ce soit, 
            à l'exception du droit accordé par l'article L. 122-6-1 du Code de la propriété intellectuelle, 
            toute interaction d'Aivoni à cet égard étant soumise au paiement par cette dernière des frais 
            y afférents ;
          </li>
          </ol>
        </p>

      </div>
      <div class="pdf-page-break">
        <p>
        <ol>
          <li>
            <span class="number">3.</span>modifier, améliorer, traduire Oliverlist, notamment à des fins de 
            correction de bugs et d'erreurs, Aivoni se réservant exclusivement ce droit conformément à 
            l'article L. 122-6-1 I 2° du Code de la propriété intellectuelle ;
          </li>
          <li>
            <span class="number">4.</span>transférer, louer, sous-louer, vendre, mettre en gage 
            ou transférer tout ou partie du titre de propriété à Oliverlist de quelque manière que ce soit ;
          </li>
          <li>
            <span class="number">5.</span>ne pas fournir de services via Oliverlist à des tiers, 
            autres qu'un utilisateur, de quelque manière que ce soit, y compris, mais sans s'y limiter, 
            à des bureaux de services, à des fournisseurs de services applicatifs (ASP), à des logiciels 
            en tant que service (SaaS) ou à l'externalisation.
          </li>
        </ol>
        </p>
        <h3 class="font-weight-bold">3. Connaissances techniques</h3>

        <p>
          Toutes les idées, le savoir-faire ou les techniques qu'Aivoni pourrait développer, y compris 
          les améliorations ou modifications apportées à ses logiciels, sont sa propriété exclusive. 
          Aivoni peut, à sa seule discrétion, développer, utiliser, commercialiser et concéder sous licence 
          tout logiciel ou matériel de traitement de données similaire ou lié aux développements d'Aivoni 
          pour le Client. Aivoni n'est pas tenue de divulguer les idées, le savoir-faire ou les techniques 
          qu'elle pourrait développer et qu'elle considère comme exclusifs et confidentiels.
        </p>
        <h2 class="font-weight-bold">6. Conditions financières</h2>

        <h3 class="font-weight-bold">1. Licence et commissions</h3>
        <p>
          L'accès à Oliverlist est soumis à la fourniture par le Client d'un moyen de paiement valide, 
          tel que défini dans les Conditions générales d'utilisation. En échange de l'utilisation d'Oliverlist, 
          le Client doit verser à Aivoni la Commission (ou Frais de réussite) et les Frais de licence. 
          (ou <strong>Platform Fee</strong>), payable mensuellement à l'avance. La Commission est calculée en 
          fonction du nombre de rendez-vous pris par le Client via Oliverlist, selon les conditions précisées 
          dans les Conditions Générales d'Utilisation. La <strong>license fee</strong> est déterminé au moment 
          de la souscription à l'offre concernée Service via Oliverlist. Les absences ne génèrent aucune 
          commission, mais les frais de licence restent dus.
        </p>
        <h3 class="font-weight-bold">2. Conditions de paiement</h3>

        <p>
          Pour la fourniture des Services, (i) les Frais de Licence sont payables d'avance sur une base mensuelle ; 
          et (ii) la Commission est facturée et due dès qu'une nomination est réputée effective et est payée conformément 
          aux conditions énoncées dans les Conditions Générales d'Utilisation. Les frais et/ou la commission n'incluent 
          pas les taxes, les droits de douane, les droits de douane, la TVA ou toute autre taxe applicable, qui doivent 
          être réglés en sus par le Client :
        </p>
        <p>
          <ol>
            <li>
              <span class="number">1.</span>Tout montant impayé portera automatiquement intérêt,
              qui courra quotidiennement jusqu'à la date de paiement intégral du principal, des intérêts, des frais
              et des frais supplémentaires, à un taux égal à cinq (5) fois le taux d'intérêt légal applicable,
              sans qu'aucune autre mise en demeure ne soit nécessaire et sans préjudice de toute demande d'indemnisation
              qu'Aivoni se réserve le droit de demander par voie judiciaire ;
            </li>
            <li>
              <span class="number">2.</span>Aivoni se réserve le droit, à sa seule discrétion, 
              avec ou sans préavis, de suspendre l'exécution de tout Service, actuel ou futur, 
              et ce jusqu'au paiement intégral des sommes dues ;
            </li>
            <li>
              <span class="number">3.</span>Tout retard de paiement des factures entraînera l'application 
              immédiate d'un intérêt de retard annuel de 12 % sur les sommes impayées ainsi que de quarante 
              (40) euros par facture pour frais de recouvrement, conformément à l'article L. 4414-10 du 
              Code de commerce.
            </li>
            <li>
              <span class="number">4.</span>Toutes les sommes restant dues par le Client à Aivoni 
              deviendront immédiatement exigibles.
            </li>
            <li>
              <span class="number">5.</span>Des frais de retard s'appliquent à la fois à la licence 
              et aux commissions.
            </li>
          </ol>
        </p>
        <p>
          Oliverlist utilise la technologie de préautorisation à valeur nulle. Cela signifie que 
          le client doit saisir un mode de paiement valide et approuver la préautorisation à valeur 
          nulle pour valider le mode de paiement. Ce faisant, le client autorise AIVONI à débiter 
          son mode de paiement pour les rendez-vous valides, conformément aux conditions décrites 
          dans les Conditions générales d'utilisation d'Oliverlist.
        </p>

      </div>
      <div class="pdf-page-break">
        <h2 class="font-weight-bold">7. Les entreprises d'Aivoni</h2>
        <p>
          Les Services seront fournis conformément aux Conditions Générales par Aivoni, qui s'engage, 
          sauf mention expresse contraire, à faire tout son possible.
        </p>
        <p>
          Sauf stipulation expresse contraire, les obligations d’Aivoni au titre des Conditions 
          Générales sont des obligations de moyens.
        </p>
        <p>
          Aivoni s'engage à ce que l'ensemble de son personnel mette en œuvre son savoir-faire et ses 
          connaissances pour la bonne exécution des Services. En cas de difficulté dans la fourniture des 
          Services, Aivoni s'engage à en informer immédiatement le Client.
        </p>
        <p>
          Aivoni se réserve le droit de modifier à tout moment les caractéristiques de ses infrastructures 
          techniques, le choix de ses fournisseurs techniques et la composition de ses équipes.
        </p>
        <p>
          Aivoni n'est pas responsable si les KPI ne sont pas atteints pour des raisons indépendantes de 
          sa volonté (ICP inexact, absence de créneaux horaires d'appel autorisés, refus du client de valider 
          les séquences d'e-mails, etc.).
        </p>
        <h2 class="font-weight-bold">8. Engagements du Client</h2>
        <p>Le Client doit:</p>
        <p>
          <ol>
            <li>
              <span class="number">1.</span>se conformer strictement aux instructions 
              d’utilisation énoncées dans les Conditions Générales d’Utilisation ;
            </li>
            <li>
              <span class="number">2.</span>ne pas importer dans Oliverlist de données 
              susceptibles de nuire à Oliverlist et/ou de porter atteinte aux droits 
              d'un tiers ;
            </li>
            <li>
              <span class="number">3.</span>disposer d'un navigateur Internet à jour, 
              ainsi que d'une connexion Internet haut débit, dont les coûts sont à 
              leur charge.
            </li>
            <li>
              <span class="number">4.</span>effectuer des sauvegardes de toutes ses données, 
              avant la première utilisation d'Oliverlist et chaque fois qu'elle le juge nécessaire. 
              Aivoni ne peut en aucun cas être tenue responsable de toute perte de données subie 
              par le Client ;
            </li>
            <li>
              <span class="number">5.</span>ne prendre aucune mesure susceptible de nuire à la 
              réputation d'Oliverlist ou d'Aivoni, aux marques déposées d'Aivoni ou de ses concédants 
              de licence ou à tout autre produit d'Aivoni ou de ses concédants de licence ;
            </li>
            <li>
              <span class="number">6.</span>utiliser le nom et les marques déposées d'Aivoni uniquement 
              de la manière prescrite par écrit par Aivoni, sauf accord contraire écrit entre les 
              Parties ;
            </li>
            <li>
              <span class="number">7.</span>informer Aivoni de tout défaut potentiel découvert 
              lors de l'utilisation d'Oliverlist ;
            </li>
            <li>
              <span class="number">8.</span>informer rapidement Aivoni de tout avis juridique, 
              réclamation ou action directement ou indirectement liée à Oliverlist et ne pas engager 
              ou engager d'action en justice ou autre procédure liée à Oliverlist sans le consentement 
              écrit préalable d'Aivoni ;
            </li>
            <li>
              <span class="number">9.</span>utiliser Oliverlist à des fins illégales ou de manière 
              illégale, y compris en violation des droits de propriété intellectuelle d'Aivoni ou 
              de tout tiers.
            </li>
          </ol>
        </p>
        <h2 class="font-weight-bold">9. Confidentialité</h2>
        <h3 class="font-weight-bold">1. Informations confidentielles</h3>
        <p>Les informations confidentielles n'incluent pas:</p>
        <p>
          <ol>
            <li>
              <span class="number">1.</span>Informations actuellement disponibles ou qui 
              deviennent accessibles au public sans que l'une ou l'autre des Parties ne viole 
              les Conditions générales ;
            </li>
            <li>
              <span class="number">2.</span>Informations légalement détenues par une partie
              avant leur divulgation par l’autre ;
            </li>
            <li>
              <span class="number">3.</span>Informations qui ne proviennent pas directement 
              ou indirectement de l'utilisation de tout ou partie des Informations 
              Confidentielles ;
            </li>
            <li>
              <span class="number">4.</span>Informations valablement obtenues auprès d’un tiers 
              autorisé à transférer ou à divulguer ces informations.
            </li>
          </ol>
        </p>
      </div>
      <div class="pdf-page-break">
        <h3 class="font-weight-bold">2. Engagement de confidentialité</h3>
        <p>
          Le Client s'engage, en son nom et au nom de ses salariés, agents, 
          sous-traitants et Clients, pendant toute la durée des Conditions Générales 
          et pour une durée de cinq (5) ans après la fin des Conditions Générales :
        </p>
          <p>
          <ol>
            <li>
              <span class="number">1.</span>Ne pas utiliser les Informations Confidentielles 
              à d'autres fins que l'exécution de ses obligations au titre des Conditions Générales ;
            </li>
            <li>
              <span class="number">2.</span>Prendre toutes les précautions qu'il prendrait avec 
              ses propres informations confidentielles précieuses, étant précisé que ces précautions 
              ne doivent pas être inférieures à celles d'un professionnel diligent ;
            </li>
            <li>
              <span class="number">3.</span>Ne pas divulguer les Informations Confidentielles 
              à qui que ce soit, par quelque moyen que ce soit, à l'exception de ses employés, 
              agents, prestataires de services ou sous-traitants pour lesquels ces informations 
              sont nécessaires au respect des obligations de chacune des Parties.
            </li>
          </ol>
        </p>
        <p>
          À l'expiration des Conditions Générales, chaque Partie devra restituer à l'autre 
          Partie, sans délai, toutes les Informations Confidentielles, quel que soit leur support, 
          qu'elle aura obtenues dans le cadre des Conditions Générales.
        </p>
        <p>
          Aucune des Parties ne conservera de copies sous quelque format que ce soit, sans
          l'accord écrit préalable exprès d'Aivoni.
        </p>
        <h2 class="font-weight-bold">10. Protection des données</h2>

        <h3 class="font-weight-bold">1. Traitement des données clients</h3>
        <p>
          Dans le cadre de l'exécution des Conditions Générales, Aivoni peut traiter, 
          entre autres, des données personnelles pour le compte du Client.
        </p>
        <p>
          Par conséquent, Aivoni agit en tant que sous-traitant, le Client étant 
          responsable de la collecte et du traitement de ces données personnelles.
        </p>
        <p>
          Les Parties ont conclu un contrat conformément aux dispositions de l'article 28 
          du Règlement (UE) 2016/679 relatif à la protection des personnes physiques à l'égard 
          du traitement des données à caractère personnel et à la libre circulation de ces données 
          (le <strong>" RGPD "</strong>), tel qu'énoncé à l'annexe A.
        </p>
        <h3 class="font-weight-bold">2. Traitement des données par Aivoni</h3>
        <p>
          En outre, dans le cadre de ses relations avec le Client, Aivoni peut traiter, 
          pour son propre compte, les données personnelles des employés, dirigeants, sous-traitants, 
          agents et/ou prestataires de services du Client.
        </p>
        <p>
          Dans ce cadre, les collaborateurs du Client disposent d'un droit d'accès et, si nécessaire, 
          de rectification, de suppression ou de portabilité des données les concernant. Ils disposent également 
          du droit de définir des directives relatives au sort de leurs données personnelles après leur décès.
        </p>
        <p>
          En outre, le personnel du Client peut s’opposer, pour des motifs légitimes, au traitement des données 
          personnelles le concernant, retirer son consentement, voire le limiter.
        </p>
        <p>
          Ces droits peuvent être exercés à tout moment en écrivant à Aivoni à 
          l'adresse suivante : contact@oliverlist.com.
        </p>
        <p>
          Le personnel du Client a la possibilité de déposer une plainte auprès 
          d’une autorité de contrôle.
        </p>
        <p>
          Le Client s’engage à informer ses salariés, dirigeants, sous-traitants, 
          agents et/ou prestataires de ces droits.
        </p>
        <p>
          Aivoni conservera les données personnelles des salariés, dirigeants, sous-traitants, 
          agents et/ou prestataires du Client pendant une durée de trois (3) ans à compter de 
          l’expiration des Conditions Générales.
        </p>
      </div>
      <div class="pdf-page-break">
        <p>
          Aivoni traitera lesdites données personnelles pour son compte exclusif
          dans le cadre des Conditions Générales et s'interdira de les
          communiquer à des tiers.
        </p>
        <p>
          Le Client obtient toutes les autorisations légales pour transcrire les appels.
        </p>
        <p>
          Aivoni continue d'agir en tant que sous-traitant pour ces nouvelles données 
          (enregistrements, transcriptions).
        </p>
        <h2 class="font-weight-bold">11. Réversibilité</h2>
        <p>
          Dans un délai de quarante-cinq (45) jours à compter de l'expiration de la Campagne, 
          le Client pourra exporter les Données Client dans les conditions définies au présent 
          article 11.
        </p>
        <p>
          À l'issue de cette période de réversibilité, Aivoni procédera à la suppression complète 
          des données personnelles contenues dans les Données Client, à l'exception des données 
          statistiques anonymes collectées par Oliverlist dans le cadre de la fourniture des 
          services au Client.
        </p>
        <h2 class="font-weight-bold">12. Responsabilité</h2>
        <p>
          Aivoni mettra tout en œuvre pour qu'Oliverlist respecte les dispositions des 
          Conditions Générales d'Utilisation. Toute garantie autre que celles prévues dans 
          les Conditions Générales est expressément exclue par Aivoni.
        </p>
        <p>
          En particulier, Aivoni ne garantit pas l'absence de bugs et, par conséquent, ne garantit 
          pas que l'utilisation d'Oliverlist sera ininterrompue et sans erreur. Aivoni rejette 
          expressément la garantie légale française des vices cachés (« <em>garantie des vices cachés</em> ») 
          prévue aux articles 1641 et suivants du Code civil français.
        </p>
        <p>
          Le Client reconnaît avoir une bonne compréhension d’Internet et de ses limites. Le Client 
          accepte notamment, mais sans s’y limiter, que les transmissions sur Internet ne sont pas sécurisées 
          et peuvent être retardées, perdues, interceptées ou altérées, et que la transmission d’Informations 
          Confidentielles sur Internet est effectuée par le Client à ses propres risques.
        </p>
        <p>
          Les Parties conviennent expressément que les dispositions du présent Article ont été convenues 
          entre elles dans le cadre d’un processus de négociation global, de sorte que chacune des Parties 
          les considère à la fois justifiées et proportionnées au regard des autres engagements pris en 
          vertu des Conditions Générales.
        </p>
        <p>
          Aivoni ne pourra être tenu responsable que des dommages directs et prévisibles au sens 
          des articles 1231-3 et 1231-4 du Code civil français, causés par le manquement d’Aivoni à 
          ses obligations au titre des Conditions Générales.
        </p>
        <p>
          Les Parties conviennent expressément qu’Aivoni ne pourra être tenu responsable 
          d’aucune perte de chiffre d’affaires ; perte de revenu ou de bénéfice ; perte de clientèle ; 
          perte d’opportunité ; atteinte à l’image ou à la réputation ; ainsi que d’aucun coût engagé 
          pour l’obtention d’un produit, logiciel, service ou technologie alternatif ; ni pour toute 
          difficulté technique rencontrée dans le routage des messages via Internet.
        </p>
        <p>
          Aivoni ne pourra être tenu responsable d’aucun dommage résultant de la destruction de 
          fichiers ou de données causée par le Client utilisant un ou plusieurs éléments fournis 
          avec Oliverlist.
        </p>
        <p>
          Si Aivoni devait être condamnée à payer une pénalité financière, pour quelque raison que ce soit, 
          le montant de l’indemnisation qui lui serait accordée ne devra pas dépasser le montant total perçu 
          par Aivoni au cours des douze (12) mois précédant la réclamation.
        </p>
        <p>
          En tout état de cause, le Client doit engager une action contre Aivoni pour manquement aux 
          Conditions Générales dans un délai de douze (12) mois à compter de la date dudit manquement, 
          ce que le Client reconnaît et accepte expressément. Aivoni ne pourra en aucun cas être tenue 
          responsable des dommages causés par le manquement du Client à ses propres obligations.
        </p>
      </div>
      <div class="pdf-page-break">
        <h2 class="font-weight-bold">13. Terminaison</h2>
        <p>
          Chaque Partie a le droit, sans préjudice de toute demande d'indemnisation qu'elle se réserve 
          le droit de demander par voie de justice, de résilier les Conditions Générales et/ou la 
          Campagne avec effet immédiat en cas de manquement grave de l'autre Partie à l'une quelconque 
          de ses obligations essentielles au titre des Conditions Générales, si la Partie en défaut ne 
          remédie pas à ce manquement dans les trente (30) jours ouvrables suivant la réception de la 
          notification du manquement par l'autre Partie par écrit, envoyée par courrier recommandé avec 
          accusé de réception.
        </p>
        <p>
          En cas de résiliation d'une Campagne pour quelque raison que ce soit, le Client devra immédiatement 
          cesser d'utiliser tout article fourni dans le cadre des Services au titre de cette Campagne.
        </p>
        <h2 class="font-weight-bold">14. Divers</h2>
        <h3 class="font-weight-bold">1. Cession/transfert des Conditions Générales</h3>
        <p>
          Aivoni aura le droit de transférer tout ou partie de ses droits et obligations au titre 
          des présentes Conditions Générales à tout tiers de son choix, y compris toute filiale qui 
          pourrait être créée et/ou en cas de fusion, de scission, de transfert partiel d'actifs ou 
          de vente de tout ou partie de son activité.
        </p>
        <p>
          Il est expressément convenu entre les Parties que toute modification de la structure du capital d'Aivoni, 
          y compris un changement de contrôle, n'affectera pas l'exécution des Conditions Générales.
        </p>
    
        <p>
          Le Client n'est pas autorisé à céder tout ou partie de ses obligations au titre des Conditions 
          Générales, de quelque manière que ce soit, sans le consentement préalable, écrit et exprès d'Aivoni.
        </p>
        <h3 class="font-weight-bold">2. Communication – Publicité</h3>
        <p>
          Le Client accepte de figurer sur la liste de référence des clients d'Aivoni™. Cette acceptation 
          inclut sa mention dans les communiqués de presse ou les comptes rendus de projets, ainsi que l'utilisation 
          des Conditions Générales comme exemple de collaboration mutuellement avantageuse à des fins marketing.
        </p>
        <h3 class="font-weight-bold">3. Notification - Calcul des délais</h3>
        <p>
          Toute notification requise ou nécessaire conformément aux dispositions des Conditions 
          Générales doit être faite par écrit et sera réputée valablement donnée si elle est envoyée 
          par e-mail à Aivoni à l'adresse contact@oliverlist.com
        </p>

        <p>
          Sauf disposition contraire dans un article des Conditions Générales, les délais sont calculés par 
          jour calendaire. Tout délai calculé à compter de la notification court à compter de la première 
          tentative de remise au destinataire, le cachet de la poste faisant foi.
        </p>
        <h3 class="font-weight-bold">4. Force Majeurea</h3>
        <p>
          Aucune des Parties ne sera tenue responsable si l’exécution de ses obligations était retardée, 
          restreinte ou rendue impossible en raison d’un cas de force majeure.
        </p>
        <p>
          Si un cas de force majeure devait survenir, l’exécution des obligations de chaque 
          Partie serait suspendue.
        </p>
        <p>
          Si le cas de force majeure devait durer plus d'un (1) mois, les Conditions générales pourraient 
          être résiliées à la demande de la partie la plus diligente, sans que la responsabilité de chacune 
          des parties ne puisse être engagée. Chaque partie supportera ses propres frais pouvant être engagés 
          du fait du cas de force majeure.
        </p>
      </div>
      <div class="pdf-page-break">
        <h3 class="font-weight-bold">5. Fournisseurs – Entrepreneurs – Sous-traitants</h3>
        <p>
          Pendant toute la durée des Conditions Générales, Aivoni sera libre de faire appel à 
          tout fournisseur, prestataire et/ou sous-traitant de son choix.
        </p>
        <p>
          Dans ce contexte, Aivoni demeure, dans les conditions prévues aux Conditions Générales, 
          responsable de la fourniture des services.
        </p>

        <h3 class="font-weight-bold">6. Preuve</h3>
        <p>
          Les registres informatisés seront conservés dans les systèmes informatiques d'Aivoni™
          dans des conditions raisonnables de sécurité et seront considérés comme les preuves
          des échanges et/ou actions effectués par les Utilisateurs, ce que le Client déclare accepter.
        </p>
        <h3 class="font-weight-bold">7. Renoncer</h3>
        <p>
          Si l'une ou l'autre des Parties ne parvient pas à exercer l'un quelconque de ses droits 
          au titre des Conditions Générales, cela ne sera pas considéré comme une renonciation à ce droit, 
          cette renonciation n'étant réputée avoir été accordée que lorsqu'elle est expressément 
          déclarée par la Partie concernée.
        </p>
        <h3 class="font-weight-bold">8. Intégralité</h3>
        <p>
          Les Conditions Générales constituent l’intégralité de l’accord entre les Parties, 
          à l’exclusion de tout autre document, notamment ceux qui pourraient être émis par le 
          Client avant ou après son acceptation des Conditions Générales.
        </p>
      
        <h3 class="font-weight-bold">9. Validité</h3>
        <p>
          Si une ou plusieurs dispositions des Conditions Générales devaient être jugées 
          invalides par un tribunal compétent, les autres dispositions conserveraient leur 
          portée et leur effet.
        </p>
        <p>
          La disposition jugée invalide sera remplacée par une autre disposition dont la portée et 
          le sens seront aussi proches que possible de ceux de la disposition invalidée, mais dans 
          le respect de la législation applicable et de l'intention mutuelle des Parties.
        </p>
        <h3 class="font-weight-bold">10. Modification des Conditions Générales</h3>
        <p>
          Aivoni se réserve le droit d’apporter, à tout moment, toute modification qu’elle juge 
          nécessaire et utile aux Conditions Générales.
        </p>
        <p>
          En cas de modification des Conditions Générales, Aivoni s'engage à faire accepter au Client 
          les nouvelles conditions générales, quinze (15) jours avant la date de leur entrée en vigueur.
        </p>

        <h2 class="font-weight-bold">15. Loi applicable - Juridiction compétente</h2>
        <p>Les Conditions Générales sont régies par le droit français.</p>
        <p>
          Les Parties acceptent expressément de soumettre tout litige relatif aux Conditions Générales 
          (entendu comme tout litige lié à leur négociation, conclusion, exécution, annulation et/ou résiliation) 
          et/ou relatif aux relations commerciales entre les Parties et à leur cessation, à la compétence 
          exclusive des tribunaux de Paris, nonobstant la pluralité de défendeurs ou les actions en garantie, 
          y compris les procédures en référé et les demandes <em>ex parte</em>.
        </p>
      </div>
      <div class="pdf-page-break">
        <h4 class="font-weight-bold">Appendix A</h4>
        <h2 class="text-venter font-weight-bold">Contrat de sous-traitance</h2>
        <p>
          À toutes fins utiles, tous les termes utilisés dans la présente annexe dont la première 
          lettre de chaque mot est en majuscule ont la même signification que dans les Conditions 
          Générales d'Aivoni.
        </p>
        <h3 class="font-weight-bold">1. Objet des présentes clauses</h3>
        <p>
          Aivoni est amenée à traiter des données personnelles dans le cadre de l'exécution 
          des Conditions Générales, y compris les données clients.
        </p>
        <p>
          Aivoni (le <strong>« Sous-traitant »</strong>) agit en tant que sous-traitant, 
          le Client (le <strong>« Responsable de traitement »</strong>) étant responsable 
          de la collecte et du traitement de ces données personnelles.
        </p>
        <p>
          Les présentes clauses ont pour objet de définir les conditions dans lesquelles le 
          sous-traitant s'engage à traiter les données personnelles définies ci-après pour le 
          compte du responsable de traitement.
        </p>
        <p>
          Dans le cadre de leur relation contractuelle, les Parties s’engagent à respecter la 
          réglementation en vigueur applicable au traitement des données personnelles et, en 
          particulier, le Règlement (UE) 2016/679 relatif à la protection des personnes physiques 
          à l’égard du traitement des données à caractère personnel et à la libre circulation de 
          ces données (le <strong>« RGPD »</strong>).
        </p>
        <h3 class="font-weight-bold">2. Description du traitement des données personnelles sous-traité</h3>
        <p>
          Le sous-traitant est autorisé à traiter, pour le compte du responsable du traitement, 
          les données personnelles nécessaires à la fourniture du ou des services.
        </p>
        <p>
          Les catégories de personnes concernées sont les utilisateurs finaux des services fournis 
          par le Client et les utilisateurs autorisés à accéder à Oliverlist par le Client.
        </p>
        <p>Les finalités du traitement sont les suivantes:</p>
        <p>
          <ol>
            <li><span class="number">1.</span>pour fournir des services;</li>
            <li>
              <span class="number">2.</span>fournir des services de gestion 
              utilisés par le Client ;
            </li>
            <li><span class="number">3.</span>à des fins statistiques;</li>
            <li>
              <span class="number">4.</span>se conformer à la législation 
              applicable ;
            </li>
            <li>
              <span class="number">5.</span>gérer la relation Client ;
            </li>
            <li><span class="number">6.</span>pour prévenir la fraude;</li>
            <li>
              <span class="number">7.</span>gérer les demandes des personnes concernées 
              pour exercer leurs droits tels que le droit d'accès, de rectification, de 
              suppression, d'opposition, d'effacement, de limitation, de portabilité et 
              concernant le sort des données personnelles après leur décès.
            </li>
          </ol>
        </p>
        <p>
          Sauf consentement des personnes concernées obtenu dans les conditions prévues 
          par la législation applicable, ces opérations ne doivent pas conduire à la création 
          de profils susceptibles de révéler des données sensibles (origines raciales ou ethniques, 
          opinions philosophiques, politiques, syndicales ou religieuses, vie sexuelle ou santé 
          des personnes).
        </p>
        <p>
          En tout état de cause, le Responsable du traitement est tenu d'informer préalablement le 
          Sous-traitant de tout autre traitement envisagé et de garantir le respect de la réglementation 
          applicable. En particulier, le Responsable du traitement est tenu de réaliser, si nécessaire, 
          une analyse d'impact relative à la protection des données du traitement envisagé, dans les 
          conditions définies à l'article 35 du RGPD.
        </p>

        <p>
          Les données personnelles traitées sont ou peuvent être les suivantes, si nécessaire, 
          compte tenu de la finalité du traitement concerné :
        </p>
      </div>
      <div class="pdf-page-break">
        <p>
        <ol>
          <li>1. identité (nom, adresse postale) ;</li>
     
          <li>2. données relatives à la profession;</li>
        </ol>
        </p>
        <p>
          Pour l'exécution du Service objet des Conditions Générales, le Responsable du 
          Traitement met à disposition du Sous-traitant les informations garantissant le 
          respect des dispositions légales en vigueur et notamment du RGPD.
        </p>
        <h3 class="font-weight-bold">3. Durée de ces clauses</h3>
        <p>
          Les présentes clauses prendront effet à compter de la date d'entrée en vigueur 
          des Conditions Générales et pendant toute la durée de validité de celles-ci.
        </p>
        <h3 class="font-weight-bold">4. Engagements du responsable du traitement</h3>
        <p>
          Le Responsable du traitement s'engage, dans le cadre de l'exécution 
          des Conditions générales, à :
        </p>
        <p>
          <ol>
            <li>
              <span class="number">1.</span>transmettre via Oliverlist uniquement les 
              données client strictement nécessaires à la fourniture des services ;
            </li>
            <li>
              <span class="number">2.</span>consigner par écrit toute instruction relative au 
              traitement des données personnelles par le sous-traitant ;
            </li>
            <li>
              <span class="number">3.</span>se conformer aux dispositions de la loi n° 78-17 
              relative à l'informatique, aux fichiers et aux libertés, du RGPD et, plus généralement, 
              de la réglementation applicable en France ;
            </li>
            <li>
              <span class="number">4.</span>superviser le traitement des données personnelles, 
              notamment en réalisant des audits conformément aux conditions préalablement 
              convenues avec le sous-traitant ;
            </li>
            <li>
              <span class="number">5.</span>garantir l’existence d’une base juridique pour le 
              traitement des données personnelles ;
            </li>
            <li>
              <span class="number">6.</span>obtenir, le cas échéant, le consentement des personnes 
              concernées au traitement et/ou au transfert de leurs données personnelles ;
            </li>
            <li>
              <span class="number">7.</span>fournir toutes les informations pertinentes 
              aux personnes concernées au moment de la collecte des données.
            </li>
          </ol>
        </p>
        <p>
          Le Sous-traitant ne sera pas responsable du non-respect par le Responsable du 
          traitement de la réglementation applicable, sauf si la loi en dispose expressément 
          autrement.
        </p>
        <h3 class="font-weight-bold">5. Engagements du sous-traitant</h3>
        <p>
          Conformément aux articles 28 et 32 ​​du RGPD, le sous-traitant s'engage à :
        </p>
        <p>
          <ol>
            <li>
              <span class="number">1.</span>prendre et maintenir toutes mesures utiles, 
              notamment techniques et organisationnelles appropriées, pour préserver la sécurité 
              et la confidentialité des données personnelles qui lui sont confiées par le 
              Responsable du traitement pour la fourniture des Services, afin d'empêcher 
              qu'elles soient déformées, altérées, endommagées ou que des personnes non autorisées 
              y aient accès ;
            </li>
            <li>
              <span class="number">2.</span>de veiller à ce que les personnes autorisées à traiter 
              des données personnelles en leur nom, outre qu'elles ont reçu la formation nécessaire 
              à la protection des données personnelles, respectent la confidentialité ou soient soumises 
              à une obligation légale de confidentialité appropriée ;
            </li>
            <li>
              <span class="number">3.</span>de se conformer aux dispositions légales applicables 
              relatives aux conditions de traitement et/ou à la destination des données fournies par 
              le Responsable du traitement ou auxquelles il aura accès dans le cadre de la fourniture 
              des Services ;
            </li>
            <li>
              <span class="number">4.</span>agir uniquement sur la seule instruction documentée 
              du Responsable du traitement pour le traitement des données personnelles en question ;
            </li>
            <li>
              <span class="number">5.</span>d'utiliser les données personnelles collectées ou 
              auxquelles il peut avoir accès uniquement aux fins de fournir les Services au 
              Responsable du traitement ;
            </li>
            <li>
              <span class="number">6.</span>à ne pas utiliser les données personnelles collectées 
              ou auxquelles il pourrait avoir accès dans le cadre de l'exécution du Contrat à des 
              fins contraires au Contrat, conformément à la réglementation applicable, et à ne les 
              transférer qu'à un tiers désigné ou autorisé par le Responsable du traitement ;
            </li>
          </ol>
        </p>
      </div>
      <div class="pdf-page-break">
        <p>
          <ol>
            <li>
              <span class="number">7.</span>ne pas revendre ni transférer de données 
              personnelles strictement confidentielles ;
            </li>
            <li>
              <span class="number">8.</span>assister le Responsable du traitement, lorsque cela 
              est possible, en mettant en œuvre des mesures techniques et organisationnelles 
              appropriées, ainsi que pour remplir son obligation de répondre aux demandes des 
              personnes concernées afin d'exercer leurs droits d'accès, de rectification, 
              d'effacement, d'opposition, de limitation et de portabilité des données ;
            </li>
            <li>
              <span class="number">9.</span>d'aider le Responsable du traitement, lorsque 
              cela est possible et à la lumière des informations qui lui ont été fournies 
              par ce dernier, à se conformer à son obligation de : (a) notifier à l'autorité 
              de contrôle une violation de données à caractère personnel ; (b) communiquer une 
              violation de données à caractère personnel à la personne concernée ; (c) réaliser 
              une analyse d'impact relative à la protection des données.
            </li>
          </ol>
        </p>
        <p>
          Le Sous-traitant peut faire appel à un autre sous-traitant pour réaliser des 
          activités de traitement spécifiques. Dans ce cas, il devra informer préalablement 
          le Responsable du traitement par écrit de toute modification proposée concernant 
          l'ajout ou le remplacement d'autres sous-traitants.
        </p>
        <p>
          Le Responsable du traitement dispose d'un délai minimum de sept (7) jours à compter 
          de la date de réception de ces informations pour formuler ses objections. Cette sous-traitance 
          ne peut être effectuée que si le Responsable du traitement n'a pas formulé d'objections 
          dans le délai convenu.
        </p>
        <p>La liste des sous-traitants de second rang est disponible ici :</p>
        <p>
          <ol>
            <li>* Apollo.io</li>
            <li>* Total enrichment</li>
            <li>* OpenAI</li>
            <li>* DeepSeek</li>
            <li>* Ringover</li>
          </ol>
        </p>
      </div>
      <!-- FIN FRANCES -->
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      user: (state) => state.authentication.user,
    }),
  },
};
</script>

<style scoped>
/* .pdf-container .pdf-page-break {
  position: relative;
  height: 1000px;
}
.pdf-container .pdf-page-break:before {
  display: block;
  content: "";
  position: absolute;
  bcampaign: solid 3px red;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  height: 1000px;
} */
#pdf-content {
  width: 210mm; /* Ancho de A4 en milímetros */
  height: auto; /* Deja que la altura sea dinámica */
  margin: 0 auto; /* Centra el contenido */
}
@media print, screen {
  #pdf-content {
    width: 800px;
    margin: 0 auto;
  }
}
.pdf-container {
  font-size: 16px;
  padding: 20px;
  line-height: 1.5;
}
.pdf-container .pdf-page-break {
  position: relative;
  padding-top: 40px;
}
.pdf-container .table-header {
  padding: 0px 20px 40px 20px;
}
.pdf-container h1 {
  font-size: 1em;
  background: #5054EB;
  color: #ffffff;
  padding: 10px 20px;
  margin-bottom: 20px;
  margin-right: 150px;
  text-align: right;
  position: relative;
}
.pdf-container .pdf-logo {
  width: 50%;
}
.pdf-container h1 span {
  font-size: 0.9em;
  position: absolute;
  left: 20px;
  text-align: left;
}
.pdf-container h2 {
  font-size: 0.85em;
  bcampaign-bottom: 2px solid #5054EB;
  margin: 0px 15px 20px 15px;
  padding: 10px;
}
.pdf-container h3 {
  font-size: 0.8em;
  padding: 10px;
  margin: 0px 15px 0px 15px;
}
.pdf-container h4 {
  text-align: center;
}
.pdf-container p {
  font-size: 0.78em;
  margin-bottom: 10px;
  padding: 0px 30px;
}
.pdf-container ol,
.pdf-container li {
  margin: 0;
  padding: 0;
}
.pdf-container ol {
  counter-reset: foo;
  display: table;
  margin-bottom: 20px;
  margin-left: 20px;
}
.pdf-container li {
  list-style: none;
  counter-increment: foo;
  display: table-row;
}

/* li::before {
  content: counter(foo) ".";
  display: table-cell;
  text-align: right;
  padding-right: 0.3em;
  color: transparent;
} */

.pdf-container li span.number {
  display: table-cell;
  text-align: right;
  padding-right: 0.3em;
}
.pdf-container li span.text {
  display: table-cell;
  text-align: left;
  padding-right: 0.3em;
}
</style>